import RectangleButton from "./RectangleButton";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";

type RectangleButtonCreatorPanelProps = {
  title: string;
  iconName: string;
  rightIcon?: JSX.Element;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
};

// This button is used for the header of the creator mode panels such as ProductsPanel, etc
const RectangleButtonCreatorPanel = (
  props: RectangleButtonCreatorPanelProps
) => {
  const { title, iconName, rightIcon, onPress, disabled, loading } = props;

  return (
    <div>
      <RectangleButton
        buttonLabel={title}
        iconLeft={
          <Icon icon={iconName} height={16} style={{ color: Colors.WHITE }} />
        }
        iconRight={rightIcon}
        onPress={onPress}
        disabled={disabled}
        loading={loading}
        altColor={Colors.BLACK}
        altTextColor={Colors.WHITE}
        altPaddingVert={14}
        altPaddingHorz={20}
        altBorderRadius={100}
        containerStyles={{ whiteSpace: "nowrap" }}
      />
    </div>
  );
};

export default RectangleButtonCreatorPanel;
